import React from 'react'
import styled from 'styled-components'
import { TeamChat } from '@rodeo-dev/team-chat'
import { TeamChatContext } from '../../../contexts/team-chat'
import PageBase from '../page_base/page_base.jsx'
import app from '../../../app'
import { getUsersForStream } from './utils.js'
import SidebarUtil from '../../../../ui/lib/sidebarutil'
import analyticsModule from '../../../library/analytics'

const ChatWrap = styled.div(props => ({
  position: 'absolute',
  right: 0,
  left: props.marginLeft,
  top: 0,
  bottom: 0,
  height: '100vh'
}))

class PageChat extends PageBase {
  constructor (props) {
    super(props, 'chat', 'chat', 'chat')
  }

  state = {
    authToken: `Bearer ${window.localStorage.getItem(app.getJwtStorageKey())}`,
    userID: app.loggedInUserTeam.userId,
    teamID: app.getTeam().id
  }

  componentDidMount () {
    this._onCollapse(true)
  }

  renderContent () {
    const { APIKey, baseURL } = app.getConfig().chat
    const isExpandedMargin = SidebarUtil.getSidebarExpand() ? 60 : 160
    const { userID, teamID, authToken } = this.state

    return this.context.chatClient
      ? (
        <ChatWrap marginLeft={isExpandedMargin}>
          <TeamChat
            APIBase={baseURL}
            authToken={authToken}
            chatClient={this.context.chatClient}
            getUsers={() => getUsersForStream(teamID)}
            mixPanel={{ track: analyticsModule.getMixpanelInstance().track }}
            streamAPIKey={APIKey}
            teamID={teamID}
            userID={userID}
          />
        </ChatWrap>
      ) : null
  }
}

PageChat.contextType = TeamChatContext

export default PageChat
